import { render, staticRenderFns } from "./arcticList.vue?vue&type=template&id=d0e4dd78"
import script from "./arcticList.vue?vue&type=script&lang=js"
export * from "./arcticList.vue?vue&type=script&lang=js"
import style0 from "./arcticList.vue?vue&type=style&index=0&id=d0e4dd78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports